import { useQueryClient, useQuery } from '@gogame/query';

import { loadResults } from 'scenes/PlayersActivities/PlayersInformation/sources/playersInformation';

import { results } from './queryKeyFactory';

export const useLoadPlayersInformation = (params, options) => {
  const queryClient = useQueryClient();
  let key = results(params);
  return useQuery(
    results(params),
    (_, { signal }) => loadResults(params, { signal }),
    {
      ...options,
      onError: (e) => {
        if (e.status === 404) {
          queryClient.setQueryData(key, {});
        }
        return e;
      },
    }
  );
};
